import React from "react";
import "./loaders.css";

/**
 * Inline button loading content: spinner + label.
 * Place inside a <button> while a request is active (keep the button disabled).
 *
 * <button disabled={busy}>{busy ? <ButtonLoader label="Saving" /> : "Save"}</button>
 */
const ButtonLoader = ({ label = "Loading", suffix = "..." }) => (
  <span className="xc-btn-loader">
    <span className="xc-btn-spinner" role="status" aria-hidden="true" />
    {label}
    {suffix}
  </span>
);

export default ButtonLoader;
